import React from "react";

function MenuItem(props) {
  return <li className="menu-item">{props.children}</li>;
}

export default MenuItem;
